import { render, staticRenderFns } from "./selectMusicTiktok.vue?vue&type=template&id=c90864f2"
import script from "./selectMusicTiktok.vue?vue&type=script&lang=js"
export * from "./selectMusicTiktok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c90864f2')) {
      api.createRecord('c90864f2', component.options)
    } else {
      api.reload('c90864f2', component.options)
    }
    module.hot.accept("./selectMusicTiktok.vue?vue&type=template&id=c90864f2", function () {
      api.rerender('c90864f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/formOverlay/selectMusicTiktok.vue"
export default component.exports